<template>
  <a :href="href" :style="{ fontSize: fontSize, color: color }">
    {{ label }}
  </a>
</template>

<script>
export default {
  name: 'UiLink',
  props: {
    label: {
      type: String,
      required: true,
    },
    href: {
      type: String,
      required: true,
    },
    color: {
      type: String,
      default: '#53627c',
    },
    fontSize: {
      type: String,
      default: '12px',
    },
  },
}
</script>
